/*
  Consent status tracking:
  - fetch initial value, as user may have consented on a previous visit.
  - monitor for consent status changing on this visit, as this occurs when
    the user clicks the buttons presented on the consent pop-up dialog.
 */
import { consentStatus, observeConsentStatusChange, THE_CONVERSATION_VENDOR_ID, } from "@theconversation/shared-components/Didomi";
import { didomiIsEnabled } from "./globalConfig";
import { postQueuedEventsToCollector } from "./dispatchEvent";
let userIsEligibleToTrackStatus = false;
setInitialDidomiUserStatus();
observeConsentStatusChange(async () => {
    userIsEligibleToTrackStatus = await consentStatus({
        vendorId: THE_CONVERSATION_VENDOR_ID,
        purpose: "measure_content_performance",
    });
    if (userIsEligibleToTrackStatus)
        postQueuedEventsToCollector();
});
export function userIsEligibleToTrack() {
    return userIsEligibleToTrackStatus;
}
function setInitialDidomiUserStatus() {
    // If Didomi isn't even enabled, default to true
    if (!didomiIsEnabled()) {
        userIsEligibleToTrackStatus = true;
        return;
    }
    consentStatus({
        vendorId: THE_CONVERSATION_VENDOR_ID,
        purpose: "measure_content_performance",
    }).then((consent) => (userIsEligibleToTrackStatus = consent));
}
